<template>
	<div>
		<div class="seckill-r">
			<div class="seckill-r-img">
				<template v-if="param.page_url.indexOf('http') != -1">
					<a :href="param.page_url" target="_blank"><img class="img-default" :src="param.pic_url" alt /></a>
				</template>
				<template v-else>
					<router-link :to="param.page_url"><img class="img-default" :src="param.pic_url" alt /></router-link>
				</template>
			</div>
			<div class="swiper-container swiper-seckill">
				<div class="swiper-wrapper">
					<div class="swiper-slide d-flex justify-content-center" v-for="(item,index) in param.list[0].goods_list" :key="index">
						<router-link :to="{path:'/pages/goods/goods',query:{id:item.id}}" target="_blank" class="new-r-item">
							<img class="img-default" :src="item.pic_url" alt />
							<div class="pic">
								<div class="show-two-lines" v-text="item.name"></div>
								<div v-text="'¥'+item.price"></div>
							</div>
						</router-link>
					</div>
				</div>
				<div class="swiper-pagination seckill-p"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		Swiper,
		SwiperSlide
	} from "vue-awesome-swiper";
	import "./index.css";
	export default {
		props: {
			param: {
				type: Object,
				default () {
					return {};
				},
			}
		},
		data() {
			return {
				
			};
		},
		mounted() {
			new Swiper(".swiper-seckill", {
				observer: true,
				observeParents: true,
				speed: 1000,
				pagination: {
					el: ".seckill-p",
					clickable: true,
				},
			});
		}
	};
</script>

<style lang="scss" scoped>
	.swiper-seckill {
		width: 266px;
		height: 120px;
	
		.swiper-pagination-bullet {
			width: 12px !important;
			height: 4px !important;
			background: #ff0e25;
			border-radius: 2px;
		}
	}
	
	.swiper-slide {
		width: 266px;
		height: 120px;
	}
	.seckill-r {
		width: 290px;
		height: 295px;
		background-color: #fff;
		padding: 12px;
		margin-top: 20px;
		box-sizing: border-box;
	
		.seckill-r-img {
			width: 266px;
			height: 150px;
			overflow: hidden;
	
			img {
				transition: 0.5s;
				-moz-transition: 0.5s;
				-webkit-transition: 0.5s;
				-o-transition: 0.5s;
			}
	
			&:hover img {
				-webkit-transform: scale(1.2);
				-moz-transform: scale(1.2);
				-o-transform: scale(1.2);
				-ms-transform: scale(1.2);
				transform: scale(1.2);
			}
		}
	
		.new-r-item {
			// width: 50%;
			display: flex;
			margin-top: 16px;
	
			img {
				height: 69px;
				width: 69px;
			}
	
			.pic {
				margin-left: 16px;
	
				:first-child {
					width: 162px;
					display: -webkit-box;
					overflow: hidden;
				}
	
				:last-child {
					font-size: 16px;
					color: #ff0e25;
					margin-top: 12px;
				}
			}
		}
	}
</style>
